export const getExpenseBillList = state => {
    return state.list
}

export const getExpenseBillOutstandingList = state => {
    return state.outstanding_list
}

export const getExpenseBillDataProps = state => {
    return state.props
}


// WEBPACK FOOTER //
// ./src/store/modules/expenseBill/getters.js